// extracted by mini-css-extract-plugin
export default {"icon":"Delete_icon__8CRrv"};